import { ApiPutRequest } from './api-put-request';
import { ApiParameters } from './api-parameters';
import { TrackingEvent } from '../../enums/tracking-event';

export class TrackingRequest extends ApiPutRequest
{
    public constructor(orderId: number, event: TrackingEvent, webapiBasepath: string)
    {
        super(  'tracking', 
                new ApiParameters(), 
                null, 
                { 
                    OrderId: orderId, 
                    Event: event 
                },
                webapiBasepath
            );
    }
}